/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { isOboRequest } from '@msdyn365-commerce/core-internal';
import { IPvaChatConnectorData } from './pva-chat-connector.data';
import { IPvaChatConnectorConfig, IPvaChatConnectorProps } from './pva-chat-connector.props.autogenerated';

export interface IPvaChatConnectorViewProps extends IPvaChatConnectorProps<IPvaChatConnectorData> {
    config: IPvaChatConnectorConfig;
}

/**
 * PvaChatConnector component
 * @extends {React.PureComponent<IPvaChatConnectorProps<IPvaChatConnectorData>>}
 */
class PvaChatConnector extends React.PureComponent<IPvaChatConnectorProps<IPvaChatConnectorData>> {
    // Loads CDN version of Botframework-Webchat library
    public componentDidMount(): void {
        if (isOboRequest(this.props.context.request)) {
            return;
        }

        const url = this.props.config.botFrameworkCDNURL || this.props.context.app.config.pvaChatConnectorBotFrameworkCDNURL;
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
    }

    public render(): JSX.Element | null {
        if (isOboRequest(this.props.context.request)) {
            return null;
        }

        return this.props.renderView(this.props);
    }
}

export default PvaChatConnector;
